import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { TreeNodeXEVPRMMessage } from "../../../Art57Node/Entity/TreeNodeXEVPRMMessage";

export class MessageQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).xevprmMessageFields;
    const createChidTemplateParams = {};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).xevprmMessageConditions;
       super(injector, [], 'XEVPRM Messages', EntityEnum.xevprmMessage,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.xevprmMessageTreeNode,TreeNodeXEVPRMMessage,AutoUploadEntityEnum.xevprmMessage,createChidTemplateParams);
       
    }
}